import React, { Component } from 'react'
import moment from 'moment'
import { Select, notification, Tabs } from 'antd'
import _ from 'lodash'
import $ from 'jquery'

import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import { __ } from '@wordpress/i18n'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const Local = _.get(window, 'VC_CONFIG.Locale')
const isLogin = _.get(this, 'props.auth.isLogin')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class MemberCobrandedcard extends Component {
  formRef = React.createRef()
  state = {
    query: {},
    listInfo: _.cloneDeep(defaultListInfo),
    tableData: [],
    tableData_Detail: [],
    selectmonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    isLoading: true,
  }

  // ALVIN 2023/05/05 調整為CC登入
  GetCCUri = () => {
    this.setState({ isSubmitData: true })
    whttp.get(API_HOST + `/api/account/cc/login`, {}, (state, res) => {
      console.log(state, res)

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false) {
        this.setState({ isSubmitData: false })
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }

      if (code !== 200) {
        this.setState({ isSubmitData: false })
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)

      this.GoCCLoginPage(data.uri)
    })
  }

  // 2023/05/05 取得並前往 CC Login Url
  GoCCLoginPage = (ccApiUrl) => {
    whttp.get(ccApiUrl, {}, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res
      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }
      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }

  GetOcaUri() {
    this.setState({ isSubmitData: true })
    whttp.get(API_HOST + `/api/account/oca/login`, {}, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }

      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }
  componentDidMount() {
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    const query = {
      start_dt: moment(firstDay).format('YYYY-MM-DD'),
      end_dt: moment(lastDay).format('YYYY-MM-DD'),
    }
    // AppHelper.updateConfig()
    this.setState({ query })
    this.control()

    // var swiper = new Swiper('.swiper-memberCard', {
    //   spaceBetween: 10,
    //   loop: true,
    //   slidesPerView: 'auto',
    //   centeredSlides: true,
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //   },
    //   pagination: { el: '.swiper-pagination' },
    //   breakpoints: { 767: { spaceBetween: 0 } },
    // });
  }
  control = () => {
    $(document).ready(function() {
      $(document).on(
        'show.bs.collapse',
        '.tbody .order-detail-info',
        function() {
          $('.order-detail-info').removeClass('show')
          //$(this).addClass('show');
        }
      )
    })
  }
  clickgetdetail = (ID = '') => {
    console.log('555555555555555555', ID)
    this.setState({ isLoading: true })
    whttp.post(
      API_HOST + '/api/account/purchaseDetail',
      {
        pur_id: ID,
      },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return this.setState({ message: '發生錯誤' })
        }

        if (code !== 200) {
          return this.setState({ message: reason })
        }
        this.setState(
          { tableData_Detail: data.purchaseDetail, isLoading: false },
          () => {
            this.refreshPicker()
          }
        )
      }
    )
  }

  fillData = (data = {}) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      }
    }

    console.log('filldata', data)
    this.formRef.current.setFieldsValue(data)
  }

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)
  render() {
    const isLogin = this.props.auth.isLogin
    let $query
    if (isLogin) {
      $query = (
        <a
          class='h6 btn btn-block btn-outline-primary rounded-pill py-4'
          role='button'
          href={`${VC_CONFIG.INDEX_URL}/payment`}>
          立即查詢
        </a>
      )
    } else {
      $query = (
        <a
          className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
          role='button'
          href='#'
          onClick={() => {
            // ALVIN 2023/05/05 調整CC Login
            // this.GetOcaUri()
            this.GetCCUri()
          }}>
          立即查詢
        </a>
      )
    }
    return (
      <div>
        <main class='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a href={`${VC_CONFIG.INDEX_URL}`}>首頁</a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a href='#'>會員權益</a>
                  </li>
                  <li class='breadcrumb-item active' aria-current='page'>
                    關於好康卡
                  </li>
                </ol>
              </nav>
            </div>
            <section class='py-3'>
              <h4 class='heading-title justify-content-center'>
                卡友優惠說明
              </h4>
            </section>
          </div>
          <div class='basic-tabs-label mb-5'>
            <ul class='nav nav-pills' id='pills-tab'>
              <li class='nav-item current_page_item highlight'>
                <a
                  class='nav-link active'
                  href={`${VC_CONFIG.INDEX_URL}/member-hkcard`}>
                  關於好康卡
                </a>
              </li>
              <li class='nav-item'>
                <a
                  class='nav-link'
                  href={`${VC_CONFIG.INDEX_URL}/member-VIP`}>
                  關於 VIP
                </a>
              </li>
              <li class='nav-item'>
                <a
                  class='nav-link'
                  href={`${VC_CONFIG.INDEX_URL}/member-cobrandedcard`}>
                  關於聯名卡
                </a>
              </li>
            </ul>
          </div>
          <div class='container'>
            <section>
              <div class='row align-items-center justify-content-center'>
                <div class='col-lg-6'>
                  <div class='row'>
                    <div class='col-md-6 col-lg-10 mx-auto'>
                      <div class='swiper-container swiper-memberCard'>
                        <div class='swiper-wrapper'>
                          <div class='swiper-slide'>
                            <img
                              class='img-contain'
                              src={`${
                                VC_CONFIG.INDEX_URL
                              }/wp-content/themes/cec/assets/img/membercard/card-discount.png`}
                              alt='好康卡'
                            />
                          </div>
                          <div class='swiper-slide'>
                            <img
                              class='img-contain'
                              src={`${
                                VC_CONFIG.INDEX_URL
                              }/wp-content/themes/cec/assets/img/membercard/card-discount.png`}
                              alt='好康卡'
                            />
                          </div>
                          <div class='swiper-slide'>
                            <img
                              class='img-contain'
                              src={`${
                                VC_CONFIG.INDEX_URL
                              }/wp-content/themes/cec/assets/img/membercard/card-discount.png`}
                              alt='好康卡'
                            />
                          </div>
                        </div>
                        <div class='swiper-pagination' />
                      </div>
                    </div>
                  </div>
                </div>
                <div class='col-lg-4 my-lg-0 my-5'>
                  <div class='text-center'>
                    <h4 class='h4 title-theme-1 text-navy mb-4'>
                      一張幫我賺錢的卡
                    </h4>
                    <h5 class='h6 text-danger mb-3'>一元1點，紅利無限大</h5>
                    <p class='note text-font mb-3'>
                      免費申請好康卡，立即申辦立即累積紅利點數，
                      次日購物出示會員卡可享點數折抵消費金額，購物省最多！
                      <span class='text-navy d-block mt-4 fw-500'>
                        免費申請，立即發卡；馬上積點，點數變現金
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <h4 class='heading-title justify-content-center'>
              好康卡專屬福利
            </h4>

            <hr class='border-top border-gray m-0' />

            <section class='pt-5'>
              <div class='row no-gutters mx-n3'>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon01.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      免費申辦會員卡
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      年滿16歲即可馬上申辦
                    </p>
                  </div>
                </div>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon02.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      生日點數飆賺
                      <strong class='fw-700 px-1 text-danger'>20</strong>倍
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      生日當天以最高結帳金額贈20倍
                      (已含原本1倍)，最高贈100萬點 **點數於48小時後自動入帳
                    </p>
                  </div>
                </div>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon03.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      <strong class='fw-700 px-1 text-danger'>1</strong>
                      元累積
                      <strong class='fw-700 px-1 text-danger'>1</strong>點
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      消費每1元都能累積紅利點數
                    </p>
                  </div>
                </div>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon04.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      <strong class='fw-700 px-1 text-danger'>100%</strong>
                      點數變現金
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      憑卡可以300點折1元，折抵無上限
                    </p>
                  </div>
                </div>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon05.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      點數終生有效
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      每年持卡消費1次，點數終生有效
                    </p>
                  </div>
                </div>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon06.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      特定商品飆點數
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      購買指定商品再多賺點數
                    </p>
                  </div>
                </div>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon07.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      電子發票中獎通知
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      中獎發票，主動通知您
                    </p>
                  </div>
                </div>
                <div class='col-sm-4 col-md-3 px-2 my-3'>
                  <div class='d-flex flex-column px-md-4'>
                    <div class='row my-5'>
                      <div class='col-3 col-md-5 col-lg-4 mx-auto'>
                        <img
                          class='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/discount/icon08.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <h5 class='h5 text-center text-navy my-4 fw-700'>
                      驚爆會員價商品
                    </h5>
                    <p class='note fw-300 text-dark text-center mb-0'>
                      多樣種類商品買到超划算
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section class='pt-0'>
              <div class='banner-with-text'>
                <div class='img-4-1 d-flex align-items-center bg-sea rounded-20'>
                  <div class='row align-items-center px-lg-5 p-4'>
                    <div class='col-lg-4 d-flex justify-content-center d-lg-block'>
                      <img
                        class='img-fluid'
                        src='/wp-content/themes/cec/assets/img/membercard/successful_purchase.svg'
                        alt=''
                      />
                    </div>
                    <div class='col-lg-8'>
                      <div class='bg-white p-lg-5 py-4 px-5 rounded text-block-inner'>
                        <h6 class='h5 text-navy mb-4'>會員購物省更多</h6>
                        <p class='p text-dark'>
                          持會員卡於店內消費1元可享1點紅利點數基本回饋，更可享有專屬會員價商品、指定商品多賺點數，不定期店內會員專屬活動(如抽獎、好康優惠券等等)，讓您每1塊錢都花得物超所值！
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <h4 class='heading-title align-items-center'>立即加入</h4>

            <hr class='border-top border-gray mt-0 mb-3' />
            <p class='p text-font text-center mb-5'>
              專屬會員價，點數變現金
            </p>

            <section class='pt-0'>
              <div class='row justify-content-center mb-5'>
                <div class='col-lg-8'>
                  <div class='memberCard-step-wrap'>
                    <div class='memberCard-step-item'>
                      {' '}
                      <span class='num'>
                        {' '}
                        <b>1</b>
                      </span>
                      <div class='info'>
                        <h6 class='h6 text-primary text-center mb-4'>
                          詳閱申請條款及細則
                        </h6>
                        <div class='px-md-5 pl-5 pr-0'>
                          <div class='row justify-content-center'>
                            <div class='col-md-4'>
                              <a
                                class='h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3'
                                role='button'
                                href={`${
                                  VC_CONFIG.INDEX_URL
                                }/member-clause`}>
                                條款與細則
                              </a>
                            </div>
                            <div class='col-md-4'>
                              <a
                                class='h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3'
                                role='button'
                                href={`${
                                  VC_CONFIG.INDEX_URL
                                }/membercard-partnerslist`}>
                                特約合作廠商名單
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class='memberCard-step-item'>
                      {' '}
                      <span class='num'>
                        {' '}
                        <b>2</b>
                      </span>
                      <div class='info'>
                        <h6 class='h6 text-primary text-center mb-4'>
                          開始申辦好康卡
                        </h6>
                        <div class='px-md-5 pl-5 pr-0'>
                          <div class='row justify-content-between mb-4'>
                            <div class='col-auto'>
                              <p class='h6 text-navy mb-md-0 mb-3'>
                                攜帶個人證件至鄰近的
                              </p>
                            </div>
                            <div class='col-md-4'>
                              <a
                                class='h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill'
                                role='button'
                                href={`${VC_CONFIG.INDEX_URL}/stores`}>
                                查詢分店位置
                              </a>
                            </div>
                          </div>
                          <div class='row justify-content-between'>
                            <div class='col-auto'>
                              <p class='h6 text-navy mb-md-0 mb-3'>
                                線上申請好康卡
                              </p>
                            </div>
                            <div class='col-md-4'>
                              <a
                                class='h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill'
                                role='button'
                                href={`${
                                  VC_CONFIG.INDEX_URL
                                }/membercard-application`}>
                                立即申請
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class='memberCard-step-item'>
                      {' '}
                      <span class='num'>
                        {' '}
                        <b>3</b>
                      </span>
                      <div class='info'>
                        <h6 class='h6 text-primary text-center mb-4'>
                          馬上領取好康卡
                        </h6>
                        <div class='px-md-5 pl-5 pr-0'>
                          <p class='h6 text-navy mb-0'>
                            立即消費即可開始累積點數，點數於次日購物始可折抵，折抵無上限，購物省最多。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class='card card-storeInfo shadow-0 card-border-width-1 rounded-20 h-100'>
                <div class='card-body'>
                  <div class='row align-items-center justify-content-center'>
                    <div class='col-8 col-md-3 mx-md-0 mx-auto'>
                      <img
                        class='img-contain'
                        src={`${
                          VC_CONFIG.INDEX_URL
                        }/wp-content/themes/cec/assets/img/membercard/credit_card2.svg`}
                        alt=''
                      />
                    </div>
                    <div class='col-md-auto'>
                      <div class='text-center'>
                        <h5 class='h4 text-navy my-4 fw-700'>
                          查詢會員卡點數
                        </h5>
                        <p class='p text-dark mb-5'>
                          已經是會員了嗎？ 立即綁定卡片，查詢點數好輕鬆！
                        </p>

                        <div class='row'>
                          <div class='col-md-9 col-6 mx-auto'>{$query}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/member/member-hkcard.js